import './index.css'
import cn from 'clsx'

import React from 'react'
import Icon, { IconKey } from 'components/ui/icon'
type Props = {
  disabled?: boolean
  checkedIcon?: IconKey
  uncheckedIcon?: IconKey
  name?: string
  value: boolean
  onChange?: ((value: boolean) => unknown) | null | undefined
}

/**
 * A switch component that provides a toggle interface with optional icons
 * @param disabled - Whether the switch is disabled
 * @param checkedIcon - Optional icon to display when the switch is checked
 * @param uncheckedIcon - Optional icon to display when the switch is unchecked
 * @param name - Optional name attribute for the input
 * @param value - The current boolean value of the switch
 * @param onChange - Callback function called when the switch value changes
 * @returns A switch input component with toggle functionality
 */
const Switch = (props: Props): React.ReactElement<'label'> => {
  const handleChange = () => {
    if (props.onChange) {
      props.onChange(!props.value)
    }
  }

  return (
    <label
      className={cn('switch', {
        'switch--disabled': props.disabled,
      })}
    >
      <div className="switch-mask">
        <input
          className="switch-input"
          disabled={props.disabled}
          checked={props.value}
          name={props.name}
          readOnly={props.disabled || !props.onChange}
          type="checkbox"
          onChange={!props.disabled ? handleChange : undefined}
        />
        <div className="switch-background" />
        <div className="switch-toggle" />
        {props.checkedIcon && (
          <div className="switch-icon switch-icon--checked">
            <Icon type={props.checkedIcon} width="12" height="12" />
          </div>
        )}
        {props.uncheckedIcon && (
          <div className="switch-icon switch-icon--unchecked">
            <Icon type={props.uncheckedIcon} width="12" height="12" />
          </div>
        )}
      </div>
    </label>
  )
}

export default Switch
